export default {
    namespaced: true,
    state: {
        sender_name: '',
        sender_email: '',
        default_name: '',
        default_email: ''
    },
    mutations: {
        setNameEmail(state, sender_information) {
            state.sender_name = sender_information.hasOwnProperty('name') ? sender_information.name : '';
            state.sender_email = sender_information.hasOwnProperty('email') ? sender_information.email : '';
        },
        setDefaultNameEmail(state, default_information) {
            state.default_name = default_information.hasOwnProperty('name') ? default_information.name : '';
            state.default_email = default_information.hasOwnProperty('email') ? default_information.email : '';
        },
        resetNameEmail(state) {
            state.sender_name = '';
            state.sender_email = '';
        },
        resetDefaultNameEmail(state) {
            state.default_name = '';
            state.default_email = '';
        }
    },
    actions: {},
    getters: {
        // 送信者名を取得
        getSenderName(state) {
            return state.sender_name;
        },
        // 送信者メールアドレスを取得
        getSenderEmail(state) {
            return state.sender_email;
        },
        getSenderLabel(state) {
            return state.sender_name + '＜' + state.sender_email + '＞';
        },
        getDefaultName(state) {
            return state.default_name;
        },
        getDefaultEmail(state) {
            return state.default_email;
        },
        getDefaultLabel(state) {
            if (state.default_name !== '' && state.default_email !== '') {
                return state.default_name + '＜' + state.default_email + '＞';
            }
            return '';
        }
    }
};
